import {
  AemRoleIds,
  AllAdminRoleIds,
  AllContentRoleIds,
  SCHOOL_PARTNER_RM_IDS,
} from "@/constants/userRoles";
import { InternalAdminRoleIdsEnum } from "@/enums/userManagement";
import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/admin/dashboard",
    component: () =>
      import(/* webpackChunkName: 'AdminDashboard' */ "@/views/admin/AdminDashboard.vue"),
    name: "AdminDashboard",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAdminRoleIds,
    },
  },
  {
    path: "/admin/manage-affiliations",
    component: () =>
      import(
        /* webpackChunkName: 'AdminManageAffiliations' */ "@/views/admin/AdminManageAffiliations.vue"
      ),
    name: "AdminManageAffiliations",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllAdminRoleIds,
    },
  },
  // Affiliation create/edit are full pages (plans/affiliation-management). Admin (41) only —
  // digest §2 access matrix; the static "new" segment must precede the ":affiliationId" param.
  {
    path: "/admin/manage-affiliations/new",
    component: () =>
      import(
        /* webpackChunkName: 'AdminAffiliationForm' */ "@/views/admin/AdminAffiliationFormView.vue"
      ),
    name: "AdminAffiliationCreate",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: [InternalAdminRoleIdsEnum.ADMIN],
    },
  },
  {
    path: "/admin/manage-affiliations/:affiliationId/edit",
    component: () =>
      import(
        /* webpackChunkName: 'AdminAffiliationForm' */ "@/views/admin/AdminAffiliationFormView.vue"
      ),
    name: "AdminAffiliationEdit",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: [InternalAdminRoleIdsEnum.ADMIN],
    },
  },
  {
    path: "/admin/manage-test-series",
    component: () =>
      import(/* webpackChunkName: 'ManageTestSeries' */ "@/views/admin/ManageTestSeries.vue"),
    name: "ManageTestSeries",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/admin/manage-test-series/questions",
    component: () =>
      import(
        /* webpackChunkName: 'ManageTestSeriesQuestions' */ "@/views/admin/ManageTestSeriesQuestions.vue"
      ),
    name: "ManageTestSeriesQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/admin/school-implementation-score",
    component: () =>
      import(
        /* webpackChunkName: 'SchoolImplementationScore' */ "@/views/admin/SchoolImplementationScore.vue"
      ),
    name: "SchoolImplementationScore",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AemRoleIds.concat(SCHOOL_PARTNER_RM_IDS),
    },
  },
  {
    path: "/admin/manage-past-year-papers",
    component: () =>
      import(
        /* webpackChunkName: 'ManagePastYearPapers' */ "@/views/admin/ManagePastYearPapers.vue"
      ),
    name: "ManagePastYearPapers",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/admin/manage-past-year-papers/questions",
    component: () =>
      import(
        /* webpackChunkName: 'ManagePastYearPaperQuestions' */ "@/views/admin/ManagePastYearPaperQuestions.vue"
      ),
    name: "ManagePastYearPaperQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    // usermgmt-8-3 — ADMIN (41) only per BR-UI-801 (RBAC guard) + screen-map S8.
    path: "/admin/navbar-config",
    component: () =>
      import(/* webpackChunkName: 'NavbarConfig' */ "@/views/admin/NavbarConfig.vue"),
    name: "NavbarConfig",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: [InternalAdminRoleIdsEnum.ADMIN],
    },
  },
] as unknown as Array<RouteRecordRaw>;
